var m_pos;

function resize(e) {
  var right = $('#right_panel');
  var left = $('#left_panel');
  var dx = m_pos - e.x;
    m_pos = e.x;
    var width = right.width() + dx;
    var wl = window.innerWidth - width;
    if (width > 200 && wl > 200) {
      right.css('width', width + 'px')
      left.css('width', 'calc( 100% - ' + width + 'px)')
    }
}

$(document).ready(function () {
  var resize_el = document.getElementById('resize');
  if (resize_el) {
    resize_el.addEventListener('mousedown', function (e) {
      $('iframe').css('pointer-events', 'none');
      m_pos = e.x;
      document.addEventListener('mousemove', resize, false);
    }, false);
    document.addEventListener('mouseup', function () {
      $('iframe').css('pointer-events', 'auto');
      document.removeEventListener('mousemove', resize, false);
    }, false);
  }
});
